import * as React from 'react';

import styles from './relative-overlay.module.css';

type Props = {
    children?: React.ReactNode;
    isOpaque: boolean;
};

export class RelativeOverlay extends React.Component<Props> {
    static defaultProps = {
        isOpaque: false,
    };

    render() {
        return (
            <div className={this.props.isOpaque ? styles['container-opaque'] : styles.container}>
                {this.props.children}
            </div>
        );
    }
}
